import { DocumentNode, gql } from '@apollo/client'

export const TRACK_ANNUAIRE_VISIT: DocumentNode = gql`
    mutation TrackAnnuaireVisit($annuaireId: Int!) {
        trackAnnuaireVisit(annuaireId: $annuaireId)
    }
`

export type AnnuaireVisitResult = 'transferred' | 'consent_needed' | 'has_structure'
